import { render, staticRenderFns } from "./MoveableComponent.vue?vue&type=template&id=67033df6&scoped=true"
import script from "./MoveableComponent.vue?vue&type=script&lang=js"
export * from "./MoveableComponent.vue?vue&type=script&lang=js"
import style0 from "./MoveableComponent.vue?vue&type=style&index=0&id=67033df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67033df6",
  null
  
)

export default component.exports